import { useState } from "react";
import axios from "axios";
import { useLoading } from "../../context/LoadingContext";

const usePatchData = (url) => {
    const { isLoading, setLoading } = useLoading();
    const [response, setResponse] = useState(null);
    const [patchError, setError] = useState(null);

    const patch = async (body) => {
        if (!url) return;

        const accessToken = sessionStorage.getItem("accessToken");
        const headers = accessToken ? { Authorization: `${accessToken}` } : {};

        try {
            setLoading(true);
            setError(null);
            const res = await axios.patch(url, body, { headers });
            setResponse(res?.data);
            return res;
        } catch (err) {
            setError(err?.response?.data);
            return null;
        } finally {
            setLoading(false);
        }
    };

    return { response, isLoading, patchError, patch };
};

export default usePatchData;
